import { render, staticRenderFns } from "./fmcg.vue?vue&type=template&id=e3c84424&scoped=true&"
import script from "./fmcg.vue?vue&type=script&lang=js&"
export * from "./fmcg.vue?vue&type=script&lang=js&"
import style0 from "./fmcg.vue?vue&type=style&index=0&id=e3c84424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c84424",
  null
  
)

export default component.exports